// extracted by mini-css-extract-plugin
export default {"particles":"Particles_particles__Ym3Pn","particle":"Particles_particle__BE3BF","floatParticle":"Particles_floatParticle__ToxSI"};